module.exports = __webpack_public_path__ + "img/18-half-lg.1861eace.jpg";